module.exports = __webpack_public_path__ + "img/yt-icon.b421ee2d.svg";